export enum AssetKind {
    CSS = 0,
    IMG = 1,
    JS = 2,
    FONT = 3,
    DOCUMENT = 4,
    FAVICON = 5
}
